exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  opacity: 0.7;\r\n  z-index: 10;\r\n  background-color: white;\r\n}\r\n\r\n.loader {\r\n  background: url(" + require("../../../assets/images/firebase-loader.gif") + ") no-repeat center fixed;\r\n  margin: auto;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/component/loader/loader.component.css
// module id = ../../../../../src/app/component/loader/loader.component.css
// module chunks = main